export class PaginationModel {
    totalcount: number;
    previewpage: number;
    nowpage: number;
    nextpage: number;
    hasnext: boolean;

    public static empty = () => {
        return new PaginationModel(0, 0, 0, 0, false);
    }

    constructor(
        totalcount: number,
        previewpage: number,
        nowpage: number,
        nextpage: number,
        hasnext: boolean
    ) {
        this.totalcount = totalcount;
        this.previewpage = previewpage;
        this.nowpage = nowpage;
        this.nextpage = nextpage;
        this.hasnext = hasnext;
    }

    public static fromJson(json: any): PaginationModel {
        return new PaginationModel(
            json["totalcount"],
            json["previewpage"],
            json["nowpage"],
            json["nextpage"],
            json["hasnext"]
        );
    }
}

export interface PaginationPayloadModel<T> {
    pageNumber: number;
    pageSize: number;
    Filters: T | undefined  | null;
}